export function getAuthToken() {
  return localStorage.getItem("token");
}
